import { FC } from 'react'

import styled from 'styled-components'

import { AddParameterButton } from 'src/Components/Buttons/AddParameterButton'
import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'
import { capitalizeFirstLetter } from 'src/Helpers/layoutHelpers'
import { ModalType, ScheduleSteps } from 'src/Types/ui'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { AdCampaignStrategyEnum } from 'src/Redux/ad-campaignApi'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`
const ContainerWithError = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
`

const SubTitle = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`
const GenresList = styled(SubTitle)`
  font-weight: 400;
`

type AdsScheduleLanguagesProps = {
  languages: string[]
  strategy?: string
}

export const AdsScheduleLanguages: FC<AdsScheduleLanguagesProps> = ({
  languages,
  strategy,
}) => {
  const { setSearch } = useCustomSearchParams()

  const handleClick = (): void => {
    setSearch({
      step: ScheduleSteps.SETTINGS,
      modal: ModalType.Languages,
    })
  }

  const buttonText =
    strategy === AdCampaignStrategyEnum.PLAYLIST
      ? 'Add playlist language(s)'
      : 'Add language'

  const titleText =
    strategy === AdCampaignStrategyEnum.PLAYLIST
      ? 'Playlist language(s)'
      : 'Languages'

  if (!languages.length) {
    return (
      <AddParameterButton onClick={handleClick}>
        <span>{buttonText}</span>
      </AddParameterButton>
    )
  }
  const languagesString = languages
    .map((language) => capitalizeFirstLetter(language || ''))
    .join(', ')

  return (
    <Container>
      <ContainerWithError>
        <Wrapper>
          <SubTitle>{titleText}</SubTitle>
          <GenresList translate='no'>{languagesString}</GenresList>
        </Wrapper>
        <PrimaryDottedButton onClick={handleClick}>Edit</PrimaryDottedButton>
      </ContainerWithError>
    </Container>
  )
}
